import { Injectable } from '@angular/core';

// Extend the Window interface to include the pendo property
declare global {
  interface Window {
    pendo?: {
      set_visitor_id: (id: string) => void;
      isReady: () => boolean;
    };
  }
}

@Injectable({
  providedIn: 'root'
})
export class PendoService {

  constructor() { }

  /**
   * Update Pendo visitor ID with the user's Firestore ID
   * This should be called when the user logs in or when an existing session is detected
   * @param userId The user's Firestore ID
   */
  public updateVisitorId(userId: string): void {
    // Wait for Pendo to be loaded and ready
    const checkPendoReady = setInterval(() => {
      if (window.pendo && typeof window.pendo.set_visitor_id === 'function') {
        clearInterval(checkPendoReady);
        
        try {
          // Update the visitor ID
          window.pendo.set_visitor_id(userId);
          console.log(`Pendo visitor ID updated to: ${userId}`);
        } catch (error) {
          console.error('Error updating Pendo visitor ID:', error);
        }
      }
    }, 100); // Check every 100ms

    // Stop checking after 10 seconds if Pendo is still not ready
    setTimeout(() => {
      clearInterval(checkPendoReady);
    }, 10000);
  }

  /**
   * Check if Pendo is loaded and ready
   * @returns true if Pendo is loaded and ready
   */
  public isPendoReady(): boolean {
    return window.pendo !== undefined && typeof window.pendo.isReady === 'function' && window.pendo.isReady();
  }
}
